// extracted by mini-css-extract-plugin
export default {"app":"LoadRecord_app__qq9Cm","detail":"LoadRecord_detail__V3dBm","btns":"LoadRecord_btns__DCoxH"};